import { createAsyncThunk } from "@reduxjs/toolkit";
import retailerMappingApi from "../../../../services/apiService/api/retailerMappingApi";
import { RETAILER_MAPPING } from "../../sliceConstants";

const retailerMappingThunkActions = {
  getRetailerMappingHistory: createAsyncThunk(
    `${RETAILER_MAPPING}/getRetailerMappingHistory`,
    async (body, { rejectWithValue, dispatch }) => {
      try {
        const response = await retailerMappingApi.getRetailerMappingHistory(body);
        response.data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
        return response.data.data;
      } catch (err) {
        return rejectWithValue(err);
      }
    }
  ),
};

export default retailerMappingThunkActions;
